export default {
    messages: {
        required: "这是必填字段",
        email: "请输入有效的电子邮件地址",
        url: "请输入有效的网址",
        minlength: "输入字数过短",
        maxlength: "输入字数过长",
        date: "请输入有效的日期",
        dateISO: "请输入有效的日期 (YYYY-MM-DD)",
        number: "请输入有效的数字",
        digits: "只能输入数字",
        creditcard: "请输入有效的信用卡号码",
        equalTo: "你的输入不相同",
        extension: "请输入有效的后缀",
        mphone: "请输入正确的手机号格式",
        tphone: "请输入正确的电话格式",
        postal: "请输入正确的邮编格式"
    },
    // 邮箱
    email: (value) => {
        return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
    },
    // 链接
    url: (value) => {
        return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
    },
    // http
    http: (value) => {
        return /(http|https):\/\/([\w.]+\/?)\S*/.test(value);
    },
    // 日期
    date: (value) => {
        return !/Invalid|NaN/.test(new Date(value).toString());
    },
    // 有效的日期 (YYYY-MM-DD)
    dateISO: (value) => {
        return /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(value);
    },
    // 可带小数点数字
    number: (value) => {
        return /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value);
    },
    // 正整数
    positiveInt: (value) => {
        return /^[1-9]\d*$/.test(value);
    },
    // 正整数和0
    positiveIntAndZero: (value) => {
        return /^([1-9]+\d*)|[0]/.test(value);
    },
    // 不可带小数点数字
    digits: (value) => {
        return /^\d+$/.test(value);
    },
    // 是否是数组
    isarr: (o) => {
        return Object.prototype.toString.call(o) == '[object Array]';
    },
    isString: (str) => {
        if(typeof str === 'string' || str instanceof String) {
            return true;
        }
        return false;
    },
    // 在某个范围内
    range: (value, param) => {
        return (value >= param[0] && value <= param[1]);
    },
    // 手机号验证
    mphone: (value) => {
        return /^(((1[3-9]{1}[0-9]{1}))+\d{8})$/.test(value);
    },
    twentyNumber: (value) => {
        return /^\d{1,20}$/.test(value);
    },
    // 座机号验证
    tphone: (value) => {
        return /^(0\d{2,3}-?\d{7,8})$/.test(value);
    },
    // 邮编验证
    postal: (value) => {
        return /^[a-zA-Z0-9 ]{3,12}$/g.test(value);
    },
    // 是否是外链
    isExternal: (path) => {
        return /^(https?:|mailto:|tel:)/.test(path);
    },
    // 只能使英文和汉字
    stringEng: (value) => {
        return /^[a-zA-Z\u4e00-\u9fa5]+$/.test(value);
    },
    // 身份证号
    idCard: (value) => {
        return /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value);
    },
    // 必须是两位小数点 不包含0
    money: (value) => {
        return /^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*))$/.test(value);
    },
    // 必须是两位小数点 包含0
    moneyZero: (value) => {
        return /^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*)|0)$/.test(value);
    },
    // 英文数字组合
    numberEng: (value) => {
        return /^[a-zA-Z0-9]+$/.test(value);
    },
    /*
    1、纯中文，纯英文
    2、或中文、英文、数字的组合
    */
    strEngNum: (value) => {
        return /^([A-Za-z0-9]|[\u4e00-\u9fa5])*$/.test(value);
    },
    // 除汉字意外的所有字符
    excStr: (value) => {
        return /^[^\u4E00-\u9FFF]+$/.test(value);
    },
    // 验证图片格式
    isImg: (value) => {
        return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(value);
    },
    // 必须字母开头， 数字字母混合
    startEnglish: (value) => {
        return /^[a-zA-Z]([a-zA-Z0-9])+$/.test(value);
    },
    // 特殊符号
    isSymbol: (value) => {
        var pattern = new RegExp("[`@#%^]");
        return !pattern.test(value);
    },
    // 英文数字组合
    numberEnglish: (value) => {
        return /^[a-zA-Z0-9]+$/.test(value);
    },
    // 6~20位，首位为字母，字母和数字组合
    account: (value) => {
        return /^[a-zA-Z]\w{4,19}$/.test(value);
    }
};
